import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../context/WorkspaceContext';
import ProjectList from '../components/ProjectList';
import ProjectDetail from '../components/ProjectDetail';
import AddProjectModal from '../components/AddProjectModal';
import API_BASE from '../config/api';

export default function Projects() {
  const { token } = useAuth();
  const { activeWorkspace, addRecentProject } = useWorkspace();
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!activeWorkspace) { setIsLoading(false); return; }
    setIsLoading(true);
    axios
      .get(`${API_BASE}/api/projects`, {
        params: { workspace_id: activeWorkspace._id },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setProjects(res.data);
        setIsLoading(false);
        const selectId = sessionStorage.getItem('vance_select_project');
        if (selectId) {
          const found = res.data.find((p) => p._id === selectId);
          if (found) {
            setSelectedProject(found);
            addRecentProject(found);
          }
          sessionStorage.removeItem('vance_select_project');
        }
      })
      .catch(() => setIsLoading(false));
  }, [activeWorkspace, token]);

  async function handleAdded(newProject) {
    try {
      const res = await axios.get(`${API_BASE}/api/projects`, {
        params: { workspace_id: activeWorkspace._id },
        headers: { Authorization: `Bearer ${token}` },
      });
      setProjects(res.data);
      setSelectedProject(res.data.find((p) => p._id === newProject._id) || null);
    } catch {
      setProjects((prev) => [newProject, ...prev]);
      setSelectedProject(newProject);
    }
  }

  function handleProjectUpdate(updatedProject) {
    setProjects((prev) =>
      prev.map((p) => (p._id === updatedProject._id ? updatedProject : p))
    );
    setSelectedProject(updatedProject);
  }

  if (!activeWorkspace) {
    return (
      <div
        style={{
          backgroundColor: '#222222',
          minHeight: 'calc(100vh - 56px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontWeight: 300,
            fontSize: '16px',
            color: '#565656',
          }}
        >
          Select a workspace to view projects
        </span>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        height: 'calc(100vh - 56px)',
        marginTop: '56px',
        backgroundColor: '#222222',
      }}
    >
      <ProjectList
        projects={projects}
        selectedId={selectedProject?._id}
        onSelect={(project) => {
          setSelectedProject(project);
          addRecentProject(project);
        }}
        onAdd={() => setShowAddModal(true)}
      />

      {isLoading ? (
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#565656',
            fontFamily: "'Roboto', sans-serif",
            fontSize: '14px',
          }}
        >
          Loading...
        </div>
      ) : selectedProject ? (
        <ProjectDetail
          key={selectedProject._id}
          project={selectedProject}
          onUpdate={handleProjectUpdate}
        />
      ) : (
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#565656',
            fontFamily: "'Roboto', sans-serif",
            fontSize: '14px',
          }}
        >
          Select a project to view details
        </div>
      )}

      <AddProjectModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={(p) => { setShowAddModal(false); handleAdded(p); }}
      />
    </div>
  );
}
